import src from "IMAGE";
export default { src, width: 565, height: 61, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AIqIiJ5JSUlVUlJSX09PT1tNTU1ZVVVVYlRUVGFaWlpoxWwLelCvvlUAAAAASUVORK5CYII="};
